<div class="flex">
  <div class="data"><span *ngIf="data.ObjectName" class="object-name">{{data?.ObjectName}}</span> {{data?.Message}}</div>
  <div class="dismiss">
    <button mat-icon-button (click)="snackBarRef.dismiss()">
      <mat-icon class="dismiss-icon">close</mat-icon>
    </button>
  </div>
</div>